/** Runtime configuration derived from Vite env vars (all public by design). */

/**
 * Base URL for API calls. In dev this is empty so requests go same-origin and
 * hit the Vite proxy (see vite.config.ts); in production set VITE_API_BASE_URL.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Blissful Intelligence Coach Portal';

/** Base URL of the client-portal app, used to build links a coach can share
 * with a client (e.g. a questionnaire's direct URL). */
export const CLIENT_PORTAL_URL = import.meta.env.VITE_CLIENT_PORTAL_URL ?? 'http://localhost:5174';

/** Versioned API prefix — every platform endpoint lives under this. */
export const API_PREFIX = '/api/v1';

/** Sentry DSN (CP-P4-T04/DEC-0040) — undefined disables error tracking entirely. */
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
